<template>
    <div class="container auction-live" v-if="auction.state == 7">
        <div class="row no-margin-rl">
            <div class="col-md-12 no-padding-rl">
                <div class="auction-live-top">
                    <div class="auction-live-header mg-sm-15">
                        <div class="bottom">
                            <div class="change-product" v-bind:class="{ d_right: (previousProduct == null), d_left: (nextProduct == null) }">
                                <button class="btn-change" v-if="previousProduct"
                                        @click="getDataBid(previousProduct.product_id); leaveChannel(auction.id, product.product_id);">
                                    <i class="fas fa-chevron-left icon-arrow mr-2"></i><span>前の商品</span>
                                </button>
                                <button class="btn-change" v-if="nextProduct"
                                        @click="getDataBid(nextProduct.product_id); leaveChannel(auction.id, product.product_id);">
                                    <span>次の商品</span><i class="fas fa-chevron-right icon-arrow ml-2"></i>
                                </button>
                            </div>
                            <div class="product-no"><span class="product-text">No.</span><span
                                class="product-id">{{ product.order }}</span>
                            </div>
                            <div class="b-product-name">
                                <h3 class="d-flex align-items-center justify-content-center">{{ product.name }}</h3>
                            </div>
                            <div class="auction-info">
                                <div class="b-info b-tag">
                                    <span class="tag tag-pink" v-if="product.is_steaming == 1"><img :src="'/img/home/icon-live.svg'" class="mr-1">LIVE</span>
                                </div>
                                <div class="b-info b-tag">
                                    <span class="tag tag-black mr-2" v-if="product.show_home == 1">オススメ</span>
                                </div>
                                <div class="b-info" v-if="auction.classification == 2 || auction.classification == 3">
                                    <span class="text">開催日時</span>{{ formatDate(auction.start_time) }}〜
                                </div>
                                <div class="b-info" v-if="auction.classification == 1 || auction.classification == 3">
                                    <span class="text">事前入札日時</span>{{ formatDate(auction.prebid_start_time) }} ～ {{ formatDate(auction.prebid_end_time) }}
                                </div>
                                <div class="content-tag d-flex">
                                    <div class="b-info b-tag-mobile" v-if="product.is_steaming == 1">
                                        <span class="tag tag-pink"><img :src="'/img/home/icon-live.svg'" class="mr-1">LIVE</span>
                                    </div>
                                    <div class="b-info b-tag-mobile" v-if="product.show_home == 1">
                                        <span class="tag tag-black mr-2">オススメ</span>
                                    </div>
                                    <div class="b-info">
                                        <span class="text">状態ランク</span>{{ product.rank.name }}
                                    </div>
                                    <div class="b-info">
                                        <span class="text">商品番号</span>{{ product.product_id }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="auction-live-content">
                        <div class="left">
                            <div class="video-product">
                                <embed v-if="youtubeStream" style="width: 100%; height: 350px"
                                       :src=urlStream>
                                <video v-if="!youtubeStream" id="player" autoplay playsinline muted controls @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused"></video>
                            </div>
                            <div class="list-image mg-sm-15 gallery">
                                <div class="item-image" v-for="image in notMainImg">
                                    <div class="b-img img-show">
                                        <a v-bind:href="image" class="test">
                                            <img @error="handleImageError" :src="image">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="info mg-sm-15">
                                <div class="item-info">
                                    <div class="right">カテゴリー</div>
                                    <div class="left">
                                        <button>{{ product.category.name }}</button>
                                    </div>
                                </div>
                                <div class="item-info">
                                    <div class="right">商品名</div>
                                    <div class="left">{{ product.name }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">状態ランク</div>
                                    <div class="left">{{ product.rank.name }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">ダメージ</div>
                                    <div class="left">{{ product.note }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">サイズ</div>
                                    <div class="left">{{ product.size }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">カラー</div>
                                    <div class="left">{{ product.color }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">素材</div>
                                    <div class="left">{{ product.material }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">付属品</div>
                                    <div class="left">{{ product.accessories }}</div>
                                </div>
                                <div class="b-comment" v-if="product.description !== null && product.description !== ''">
                                    <div class="title">出品者のコメント</div>
                                    <div class="text">{{ product.description }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="current-price">
                                <div class="b-current-price">
                                    <div class="top">
                                        <div class="price">
                                            <span class="number">{{ formatPrice(amountBid) }}</span>
                                            <span class="text">JPY</span>
                                        </div>
                                        <div class="tax-fee">
                                            <span class="text">消費税手数料込</span>
                                            <span class="number">{{ formatPrice(amountBid*1.21) }} JPY</span>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <div class="b-price-up">
                                            <span class="text-center"><i class="fas fa-sort-up"></i></span>
                                            <button class="price-up" v-if="product.is_steaming == 1 && isButtonDisabled && isPause"
                                                    @click="handleUpBidPrice('priceIncreaseSmall', auction.id, product.product_id, product.id)">
                                                +{{ handlePriceRange(amountBid).priceIncreaseMin }}<br>JPY</button>
                                            <button class="price-up btn-disabled" v-if="product.is_steaming == 1 && (!isButtonDisabled || !isPause)">+{{ handlePriceRange(amountBid).priceIncreaseMin }}<br>JPY</button>
                                            <button class="price-up btn-disabled" v-if="product.is_steaming != 1">+{{ handlePriceRange(amountBid).priceIncreaseMin }}<br>JPY</button>
                                        </div>
                                        <div class="b-price-up">
                                            <span class="text-center"><i class="fas fa-sort-up"></i></span>
                                            <button class="price-up" v-if="product.is_steaming == 1 && isButtonDisabled && isPause"
                                                    @click="handleUpBidPrice('priceIncreaseBig', auction.id, product.product_id, product.id)">
                                                +{{ handlePriceRange(amountBid).priceIncreaseMax }}<br>JPY</button>
                                            <button class="price-up btn-disabled" v-if="product.is_steaming == 1 && (!isButtonDisabled || !isPause)">+{{ handlePriceRange(amountBid).priceIncreaseMax }}<br>JPY</button>
                                            <button class="price-up btn-disabled" v-if="product.is_steaming != 1">+{{ handlePriceRange(amountBid).priceIncreaseMax }}<br>JPY</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="sold-out" v-if="(amountBid > product.lowest_winning_price) && histories.length">売り切り</div>
                                <div class="tag-reset" v-if="product.is_reset == 1">再セリ</div>
                                <div class="tag">現在価格</div>
                                <div class="triangle"></div>
                            </div>
                            <div class="b-your-bid">
                            <div class="text-updated" v-if="!isPause && product.is_steaming == 1"><i class="icon fas fa-exclamation-circle"></i><span>会場入札価格を入力中です。少々お待ちください。</span></div>
                            </div>
                            <div class="title mg-sm-15" v-if="amountMyBid">あなたの入札価格</div>
                            <div class="b-your-bid mg-sm-15" v-if="amountMyBid">
                                <div class="price">
                                    <span class="number">{{ formatPrice(amountMyBid) }}</span>
                                    <span class="text">JPY</span>
                                </div>
                                <div class="your-bid">消費税手数料込 {{ formatPrice(amountMyBid*1.21) }} JPY</div>

                                <div class="text-updated" v-if="product.state == 11 && (amountMyBid < amountBid)"><i class="icon fas fa-exclamation-circle"></i><span>入札価格が更新されています。</span></div>
                                <div class="text-updated" v-else-if="product.state == 6 && product.member_id == member.id"><i class="icon fas fa-exclamation-circle"></i><span>あなたが落札権利者です。</span></div>
                                <div class="text-updated" v-else-if="product.state == 6 && product.member_id != member.id"><i class="icon fas fa-exclamation-circle"></i><span>あなたは落札者ではありません。</span></div>
                                <div class="text-updated" v-else-if="(product.state == 4 || product.state == 9) && auction.state == 7"><i class="icon fas fa-exclamation-circle"></i><span>あなたは落札者ではありません。</span></div>
                            </div>
                            <div class="title mg-sm-15">入札履歴</div>
                            <HistoryBidComponent :histories="histories"/>
                            <div class="b-favorite">
                                <button @click="favorite(!empty(checkFavorite), product.product_id, member.id, auction.id)" class="btn-favorite">
                                    <i class="icon-start fas fa-star" :style="!empty(checkFavorite) ? 'color: #E52D51' : 'color: #D0CDC8'"></i> {{ countFavorite }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="auction-live-bottom mg-sm-15">
                    <div class="exhibition-list">
                        <h3 class="title">出品リスト</h3>
                        <div class="list">
                            <div class="item-list" v-for="(image, index) in listImgAuction"
                                 @click="getDataBid(productAuction[index].product_id); leaveChannel(auction.id, product.product_id); backToTop();">
                                <div class="b-img">
                                    <img @error="handleImageError" :src="image">
                                </div>
                                <div>
                                    <div class="no-product">No. <strong>{{ productAuction[index].order }}</strong></div>
                                    <div class="name">{{ productAuction[index].name }}</div>
                                </div>
                                <div v-if="productAuction[index].is_steaming == 1" class="tag"><img :src="'/img/home/icon-live.svg'" class="mr-1">LIVE</div>
                            </div>
                        </div>
                    </div>
                    <div class="list-btn" v-if="product.model_number !== null && product.model_number !== ''">
                        <div class="item-btn">
                            <div class="text-search-produt">類似商品を検索する</div>
                            <div class="noti">（外部サイト）</div>
                        </div>
                        <div class="item-btn">
                            <a v-bind:href="getLink(product.model_number, 1)" target="_blank">
                                <button>楽天<i class="far fa-calendar ml-1"></i></button>
                            </a>
                        </div>
                        <div class="item-btn">
                            <a v-bind:href="getLink(product.model_number, 2)" target="_blank">
                                <button>ヤフオク<i class="far fa-calendar ml-1"></i></button>
                            </a>
                        </div>
                        <div class="item-btn">
                            <a v-bind:href="getLink(product.model_number, 3)" target="_blank">
                                <button>メルカリ<i class="far fa-calendar ml-1"></i></button>
                            </a>
                        </div>
                    </div>
                    <div class="bid-history" v-if="product.model_number !== null && product.model_number !== ''">
                        <div v-if="productsSimilar && productsSimilar.length > 0">
                            <div class="title">同じ型番の落札履歴</div>
                            <div class="list-product">
                                <div class="item-product" v-for="product in productsSimilar">
                                    <div class="pd-img">
                                        <div class="b-img">
                                            <img @error="handleImageError" :src="product.imageS3">
                                        </div>
                                    </div>
                                    <div class="des-product">
                                        <div class="name">{{ product.name }}</div>
                                        <div class="time"><span>落札日時</span>{{ formatDate(product.bids[0].created_at) }}</div>
                                        <div class="price">
                                            <button>落札価格</button>
                                            <span class="number">{{ product.bids[0].amount }} JPY</span>
                                        </div>
                                    </div>
                                    <div class="b-rank">
                                        <div class="text">RANK</div>
                                        <div class="rank">{{ product.rank.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="change-product-bottom" v-if="previousProduct == null && product && nextProduct">
                        <button class="btn-change visible"><i
                            class="fas fa-chevron-left icon-arrow m-2"></i><span>前の商品</span></button>
                        <div class="order">No. {{ product.order }} <span>/ {{ productAuction.length }}</span></div>
                        <button class="btn-change" v-if="nextProduct" @click="getDataBid(nextProduct.product_id); leaveChannel(auction.id, product.product_id)"><span>次の商品</span><i
                            class="fas fa-chevron-right icon-arrow ml-2"></i>
                        </button>
                    </div>
                    <div class="change-product-bottom" v-if="previousProduct && product && nextProduct">
                        <button class="btn-change" v-if="previousProduct"
                                @click="getDataBid(previousProduct.product_id); leaveChannel(auction.id, product.product_id)"><i
                            class="fas fa-chevron-left icon-arrow mr-2"></i><span>前の商品</span></button>
                        <div class="order">No. {{ product.order }} <span>/ {{ productAuction.length }}</span></div>
                        <button class="btn-change" v-if="nextProduct" @click="getDataBid(nextProduct.product_id); leaveChannel(auction.id, product.product_id)"><span>次の商品</span><i
                            class="fas fa-chevron-right icon-arrow ml-2"></i>
                        </button>
                    </div>
                    <div class="change-product-bottom" v-if="previousProduct && product && nextProduct == null">
                        <button class="btn-change" v-if="previousProduct"
                                @click="getDataBid(previousProduct.product_id); leaveChannel(auction.id, product.product_id)"><i
                            class="fas fa-chevron-left icon-arrow mr-2"></i><span>前の商品</span></button>
                        <div class="order">No. {{ product.order }} <span>/ {{ productAuction.length }}</span></div>
                        <button class="btn-change visible"><span>次の商品</span><i class="fas fa-chevron-right icon-arrow ml-2"></i>
                        </button>
                    </div>
                    <div class="btn-back">
                        <a href="/home"><button>トップページに戻る</button></a>
                    </div>
                </div>
                <div class="bid-mobile">
                    <div class="current-price">
                        <div class="b-current-price">
                            <div class="top">
                                <div class="price">
                                    <span class="number">{{ formatPrice(amountBid) }}</span>
                                    <span class="text">JPY</span>
                                </div>
                                <div class="tax-fee">
                                    <span class="text">消費税手数料込</span>
                                    <span class="number">{{ formatPrice(amountBid*1.21) }} JPY</span>
                                </div>
                            </div>
                            <div class="bottom">
                                <div class="b-price-up">
                                    <button class="price-up" v-if="product.is_steaming == 1 && isButtonDisabled && isPause"
                                            @click="handleUpBidPrice('priceIncreaseSmall', auction.id, product.product_id, product.id)">
                                        +{{ handlePriceRange(amountBid).priceIncreaseMin }} JPY</button>
                                    <button class="price-up btn-disabled" v-if="product.is_steaming == 1 && (!isButtonDisabled || !isPause)">+{{ handlePriceRange(amountBid).priceIncreaseMin }} JPY</button>
                                    <button class="price-up btn-disabled" v-if="product.is_steaming != 1">+{{ handlePriceRange(amountBid).priceIncreaseMin }} JPY</button>
                                </div>
                                <div class="b-price-up">
                                    <button class="price-up" v-if="product.is_steaming == 1 && isButtonDisabled && isPause"
                                            @click="handleUpBidPrice('priceIncreaseBig', auction.id, product.product_id, product.id)">
                                        +{{ handlePriceRange(amountBid).priceIncreaseMax }} JPY</button>
                                    <button class="price-up btn-disabled" v-if="product.is_steaming == 1 && (!isButtonDisabled || !isPause)">+{{ handlePriceRange(amountBid).priceIncreaseMax }} JPY</button>
                                    <button class="price-up btn-disabled" v-if="product.is_steaming != 1">+{{ handlePriceRange(amountBid).priceIncreaseMax }} JPY</button>
                                </div>
                            </div>
                        </div>
                        <div class="sold-out" v-if="(amountBid > product.lowest_winning_price) && histories.length">売り切り</div>
                        <div class="tag-reset" v-if="product.is_reset == 1">再セリ</div>
                        <div class="tag">現在価格</div>
                        <div class="triangle"></div>
                    </div>
                </div>
                <div class="show-img d-none">
                    <div class="b-show-img">
                        <div class="top"><i class="fas fa-times icon-close"></i></div>
                        <div class="bottom">
                            <div class="icon"><i class="fas fa-chevron-left"></i></div>
                            <div class="show"><img :src="'/img/backend/image-default.png'"></div>
                            <div class="icon"><i class="fas fa-chevron-right"></i></div>
                        </div>
                    </div>
                </div>
                <div class="modal-won-bid">
                    <div class="modal-overlay" v-if="isModalOpen">
                        <div class="modal-1">
                            <span class="close" @click="closeModal">&times;</span>
                            <div class="content">
                                <div class="b-img">
                                    <img src="/img/backend/won_bid_min.png">
                                </div>
                                <div class="b-content">
                                    おめでとうございます。<br>
                                    あなたが落札者です。<br>
                                    商品番号: {{ idProductFinish }}<br>
                                    落札価格：{{ formatPrice(priceBidFinish) }}円
                                    <div class="text-small">（消費税手数料込：{{ formatPrice(priceBidFinish*1.21) }}円）</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container auction-live" v-else>
        <div class="row">
            <div class="col-md-12 empty-live">
                <div class="b-text">
                    <div class="text">
                        オークションは終了しました。<br>
                        落札者にお支払い内容を連絡致します。<br>
                        次回オークションのご参加もお待ちしております。
                    </div>
                    <div class="b-buttom">
                        <a href="/home">
                            <button class="btn-home">トップページに戻る</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HistoryBidComponent from './HistoryBidComponent';
    import SimpleLightbox from 'simplelightbox';
    import 'simplelightbox/dist/simple-lightbox.min.css';
    export default {
        mounted() {

        },
        async created() {
            await this.getDataBid();

            await this.playWowza();

            Echo.channel('auction.live')
                .listen('.auction.live', (e) => {
                    this.getDataBid();
                });

            Echo.channel('auction.' + this.auction.id)
                .listen('.auction.end', (e) => {
                    let btnLive = document.getElementsByClassName("btn-live");

                    btnLive[0].classList.remove('d-flex');
                    btnLive[0].classList.add('d-none');
                    this.auction.state = e.auction.state;
                    this.auction.is_steaming = e.auction.is_steaming;
                });

            Echo.channel('auction.' + this.auction.id)
                .listen('.auction.trackProductLive', (e) => {
                    if (this.product.product_id != e.auctionProduct.product_id) {
                        this.leaveChannel(this.auction.id, this.product.product_id);
                        this.getDataBid(e.auctionProduct.product_id);
                    }
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.start', (e) => {
                    this.product.is_steaming = e.auctionProduct.is_steaming;
                    this.product.state = e.auctionProduct.state;
                    this.product.member_id = e.auctionProduct.member_id;
                    this.isButtonDisabled = true;
                    this.isPause = true;
                    if (this.product.state == 6 && this.product.member_id == this.member.id) {
                        this.isModalOpen = true;
                        this.priceBidFinish = this.amountBid;
                        this.idProductFinish = this.product.product_id;
                    }
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.sent', (e) => {
                    if (this.amountBid || this.amountBid == 0) {
                        this.amountBid = e.bid.amount;
                    }
                    this.histories.unshift(e.bid);
                    if (this.isButtonDisabled) {
                        this.disableAuctionButton()
                    }
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.pause', (e) => {
                    this.isButtonDisabled = !(e.product.is_pause);
                    this.isPause = !(e.product.is_pause);
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.remove', (e) => {
                    let id = e.product.product_id;
                    Echo.leave('bid.' + this.auction.id + '.' + this.product.product_id)
                    this.getDataBid(id);
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.fail', (e) => {
                    this.product.state = e.product.state;
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.reset', (e) => {
                    if (this.product.product_id == e.product.product_id) {
                        let id = e.product.product_id;
                        this.getDataBidNew(id);
                        this.histories = [];
                        this.isModalOpen = false;
                    }
                });

            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                .listen('.bid.startPrice', (e) => {
                    this.amountBid = e.amountBidStart;
                });

            this.initSimpleLightbox();
        },
        data: function () {
            return {
                histories: [],
                auction: null,
                productAuction: null,
                product: null,
                previousProduct: null,
                nextProduct: null,
                productsSimilar: null,
                notMainImg: null,
                listImgAuction: null,
                amountBid: null,
                amountMyBid: null,
                isButtonDisabled: false,
                member: null,
                checkFavorite: null,
                countFavorite: 0,
                isPause: false,
                isModalOpen: false,
                lightbox: null,
                youtubeStream: false,
                urlStream: null,
                priceBidFinish: 0,
                idProductFinish: 0,
            }
        },
        methods: {
            async playWowza() {
                if (!this.youtubeStream) {
                    const player = new WowzaRtc.WowzaWebRtcPlayer('player');
                    player.start(
                        process.env.MIX_WOWZA_WSS,
                        process.env.MIX_WOWZA_APP_NAME,
                        process.env.MIX_WOWZA_STREAM_NAME
                    );
                }
            },

            updatePaused(event) {
                if (event.type === "pause") {
                    this.playWowza();
                }
            },

            async getDataBid(id = null) {
                await axios.post(id ? `/member/bid/get-data-live-bid?id=${id}` : '/member/bid/get-data-live-bid')
                    .then( response => {
                        this.auction = response.data.auction;
                        this.product = response.data.product;
                        this.previousProduct = response.data.previousProduct;
                        this.nextProduct = response.data.nextProduct;
                        this.notMainImg =  response.data.notMainImg;
                        this.listImgAuction = response.data.listImgAuction;
                        this.productAuction = response.data.productAuction;
                        this.productsSimilar = response.data.productsSimilar;
                        this.amountMyBid =  response.data.amountMyBid
                        this.amountBid = response.data.product.amount;
                        this.histories = response.data.histories;
                        this.member = response.data.member;
                        this.checkFavorite = response.data.checkFavorite;
                        this.countFavorite = response.data.countFavorite;
                        this.isButtonDisabled = response.data.product.is_steaming == 1 && response.data.product.is_pause == 0;
                        this.isPause = response.data.product.is_steaming == 1 && response.data.product.is_pause == 0;

                        if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
                            this.youtubeStream = true;
                            this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
                        } else {
                            this.youtubeStream = false;
                            this.urlStream = null;
                        }

                        if (id) {
                            Echo.leave();

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.start', (e) => {
                                    this.product.is_steaming = e.auctionProduct.is_steaming;
                                    this.product.state = e.auctionProduct.state;
                                    this.product.member_id = e.auctionProduct.member_id;
                                    this.isButtonDisabled = true;
                                    this.isPause = true;
                                    if (this.product.state == 6 && this.product.member_id == this.member.id) {
                                        this.isModalOpen = true;
                                        this.priceBidFinish = this.amountBid;
                                        this.idProductFinish = this.product.product_id;
                                    }
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.sent', (e) => {
                                    if (this.amountBid || this.amountBid == 0) {
                                        this.amountBid = e.bid.amount;
                                    }
                                    this.histories.unshift(e.bid);
                                    if (this.isButtonDisabled) {
                                        this.disableAuctionButton()
                                    }
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.remove', (e) => {
                                    let id = e.product.product_id
                                    Echo.leave('bid.' + this.auction.id + '.' + this.product.product_id)
                                    this.getDataBid(id);
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.pause', (e) => {
                                    this.isButtonDisabled = !(e.product.is_pause);
                                    this.isPause = !(e.product.is_pause);
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.fail', (e) => {
                                    this.product.state = e.product.state;
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.reset', (e) => {
                                    if (this.product.product_id == e.product.product_id) {
                                        let id = e.product.product_id;
                                        this.getDataBidNew(id);
                                        this.histories = [];
                                    }
                                });

                            Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                                .listen('.bid.startPrice', (e) => {
                                    this.amountBid = e.amountBidStart;
                                });

                            this.destroySimpleLightbox();

                            this.initSimpleLightbox();
                        }
                    })
                    .catch( error => {

                    })
            },

            async getDataBidNew(id) {
                await axios.post(`/member/bid/get-data-live-bid?id=${id}`)
                    .then(response => {
                        this.auction = response.data.auction;
                        this.product = response.data.product;
                        this.previousProduct = response.data.previousProduct;
                        this.nextProduct = response.data.nextProduct;
                        this.notMainImg = response.data.notMainImg;
                        this.listImgAuction = response.data.listImgAuction;
                        this.productAuction = response.data.productAuction;
                        this.productsSimilar = response.data.productsSimilar;
                        this.amountMyBid = response.data.amountMyBid
                        this.amountBid = response.data.product.amount;
                        this.histories = response.data.histories;
                        this.member = response.data.member;
                        this.checkFavorite = response.data.checkFavorite;
                        this.countFavorite = response.data.countFavorite;
                        this.isButtonDisabled = response.data.product.is_steaming == 1 && response.data.product.is_pause == 0;
                        this.isPause = response.data.product.is_steaming == 1 && response.data.product.is_pause == 0;

                        if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
                            this.youtubeStream = true;
                            this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
                        } else {
                            this.youtubeStream = false;
                            this.urlStream = null;
                        }

                        this.destroySimpleLightbox();

                        this.initSimpleLightbox();
                    })
                    .catch(error => {

                    })
            },

            formatDate(dateString) {
                const date = new Date(dateString);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');

                return `${year}/${month}/${day} ${hours}:${minutes}`;
            },

            handleImageError(event) {
                event.target.src = '/img/backend/image-default.png';
                event.target.parentNode.href = '/img/backend/image-default.png';
            },

            formatPrice(price) {
                return price ? price.toLocaleString(undefined, {maximumFractionDigits: 0}) : 0;
            },

            async handleUpBidPrice(type, auction, product, auctionProduct) {
                if (this.isModalOpen == true) {
                    this.isModalOpen = false;
                }

                await axios({
                    method: 'post',
                    url: `/bid/${auction}/${product}/${auctionProduct}/update-price-bid`,
                    data: {
                        type: type,
                    }
                })
                    .then(response => {
                        if (response.data.amountMyBid != null) {
                            if (response.data.amountMyBid == 'endLive') {
                                window.location.href = '/home';
                            } else {
                                this.amountMyBid = response.data.amountMyBid.amount;
                            }
                        }
                    })
                    .catch();
            },

            handlePriceRange(amountBid) {
                let priceIncreaseMin = null;
                let priceIncreaseMax = null;

                if (amountBid >= 0 && amountBid <= 5000) {
                    priceIncreaseMin = 500;
                    priceIncreaseMax = 1000;
                } else if (amountBid > 5000 && amountBid <= 100000) {
                    priceIncreaseMin = 1000;
                    priceIncreaseMax = 10000;
                } else if (amountBid > 100000 && amountBid <= 500000) {
                    priceIncreaseMin = 5000;
                    priceIncreaseMax = 50000;
                } else if (amountBid > 500000 && amountBid <= 5000000) {
                    priceIncreaseMin = 10000;
                    priceIncreaseMax = 100000;
                } else if (amountBid > 5000000) {
                    priceIncreaseMin = 50000;
                    priceIncreaseMax = 500000;
                }

                return {
                    priceIncreaseMin: priceIncreaseMin,
                    priceIncreaseMax: priceIncreaseMax
                }
            },

            disableAuctionButton() {
                this.isButtonDisabled = false;
                const delay = 2000;

                setTimeout(() => {
                    this.isButtonDisabled = true;
                }, delay);
            },

            leaveChannel(auctionId, productId) {
                Echo.leave('bid.' + auctionId + '.' + productId);
            },

            empty(variable) {
                return !variable;
            },

            async favorite(active, productId, memberId, auctionId) {
                if (active) {
                    await this.removeFavorite(productId, memberId)
                } else {
                    await this.addFavorite(productId, memberId, auctionId)
                }
            },

            async removeFavorite(productId, memberId) {
                await axios({
                    method: 'post',
                    url: `/member/bid/removeFavorite`,
                    data: {
                        product_id: productId,
                        member_id: memberId,
                    },
                })
                    .then(response => {
                        if (response.status === 200) {
                            this.checkFavorite = false;
                            this.countFavorite = response.data.result;
                        }
                    })
                    .catch(error => {
                        this.checkFavorite = true;
                    });
            },

            async addFavorite(productId, memberId, auctionId) {
                await axios({
                    method: 'post',
                    url: `/member/bid/addFavorite`,
                    data: {
                        product_id: productId,
                        member_id: memberId,
                        auction_id: auctionId,
                    },
                })
                    .then(response => {
                        if (response.status === 200) {
                            this.checkFavorite = true;
                            this.countFavorite = response.data.result;
                        }
                    })
                    .catch(error => {
                        this.checkFavorite = false;
                    });
            },

            getLink(productSerial, type) {
                let url = '';

                switch (type) {
                    case 1:
                        url = `https://search.rakuten.co.jp/search/mall/${productSerial}`
                        break;
                    case 2:
                        url = `https://auctions.yahoo.co.jp/closedsearch/closedsearch?p=${productSerial}`
                        break;
                    case 3:
                        url = `https://jp.mercari.com/search?keyword=${productSerial}`
                        break;
                }

                return url;
            },

            closeModal() {
                this.isModalOpen = false;
            },

            initSimpleLightbox() {
                this.$nextTick(() => {
                    this.lightbox = new SimpleLightbox('.gallery a', {});
                });
            },

            async destroySimpleLightbox() {
                if (this.lightbox) {
                    await this.lightbox.destroy();
                }
            },

            backToTop() {
                this.$nextTick(() => {
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                });
            }
        },
       components: {
            HistoryBidComponent
        }
    }
</script>
